const CaseStatusDisplayName = {
  Automated: 'Automated',
  Dormant: 'Dormant',
  CAC: 'Manual',
  Done: 'Automated',
  'Case Created': 'In Progress',
  'In Process': 'In Progress',
  'Data Collected': 'In Progress',
  Cancelled: 'Cancelled',
  'Did not code': 'Cancelled',
  Updated_Manual: 'Updated to Manual ',
  CLOSED_NON_CHARGEABLE: 'Closed Non-chargeable'
};

const ProcessStatusDisplayName = {
  'Process Created': 'In Progress (Building Case)',
  'Waiting for data': 'In Progress (Building Case)',
  'Data Collected': 'In Progress (Case Built)',
  'Prediction in Progress': 'In Progress (Predicting)',
  Predicted: 'In Progress (Manual)',
  'At Coder': 'Waiting for Coder',
  Done: '',
  Error: 'Requires attention'
};

const DescriptionDisplayValues = {
  Automated: `Sent to billing`,
  CAC: 'Sent to CAC',
  AboveThreshhold: 'Prediction above confidence threshhold',
  BelowThreshhold: 'Prediction lower than confidence threshhold',
  Cancelled: 'Requires attention',
  'Did not code': 'Requires attention',
  Updated_Manual: 'Due to Addendum',
  CLOSED_NON_CHARGEABLE: 'Closed Non-chargeable'
};

const ReasonDictionary: Record<string, string> = {
  'Happy Path Prediction': 'Prediction High Confidence',
  'Happy Path Rule': 'Rule High Confidence',
  'Sched Department not in Dictionary':
    'Scheduling Department not Valid for Processing'
};

export {
  CaseStatusDisplayName,
  ProcessStatusDisplayName,
  DescriptionDisplayValues,
  ReasonDictionary
};
